import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleUpdateUnit } from "../../../api/units";


export default function UpdateUnit({ isVisible, setVisible, selected }: any) {
    const queryClient = useQueryClient();
    const [form] = Form.useForm();

    const { mutate, isPending } = useMutation({
        mutationFn: handleUpdateUnit,
        onSuccess: () => {
            message.success("Updated Successfully");
            form.resetFields();
            setVisible(false);
            queryClient.invalidateQueries({ queryKey: ["units"] });
        },
        onError: () => {
            message.error("Something went wrong");
        },
    });

    const onSubmit = async () => {
        const { name } = await form.getFieldsValue();
        const data = { name };
        await mutate({ data, _id: selected?._id });
    };

    const clearForm = async () => {
        form.resetFields();

    };


    useEffect(() => {
        form.setFieldsValue({ name: selected?.name })
    }, [selected])


    return (
        <Modal
            open={isVisible}
            title="Update Business Unit"
            onCancel={() => setVisible(false)}
            footer={[
                <Button key="back" onClick={clearForm}>
                    Clear
                </Button>,
                <Button
                    key="submit"
                    form="updateUnit"
                    htmlType="submit"
                    type="primary"
                    onSubmit={onSubmit}
                    loading={isPending}
                >
                    Submit
                </Button>,
            ]}
        >
            <Form
                id="updateUnit"
                form={form}
                name="normal_login"
                className="login-form"
                onFinish={onSubmit}
                layout="vertical"
            >
                <Row gutter={[16, 0]}>
                    <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            name="name"
                            label={"Business Unit Name"}
                            rules={[
                                {
                                    required: false,
                                    message: "Please enter business name",
                                },
                            ]}
                        >
                            <Input type="text" placeholder="Business Unit Name" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
